import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import { useFormContext } from '@context/FormContext'

import HvacSales from './HvacSales'

const HVAC = ({ currentStepIndex, setValidationSchema, setBlockNextStepUntilHowHeated, values: valuesProp }) => {
  const { values: valuesFromContext, setFieldValue } = useFormContext()
  const values = valuesFromContext !== undefined && valuesFromContext !== null ? valuesFromContext : (valuesProp || {})

  if (!values) return null

  const props = { currentStepIndex, setValidationSchema, setBlockNextStepUntilHowHeated, values }

  // Automatically set salesOrService to 'sales' for HVAC path
  // The 'hvac-service' path goes directly to ServiceTitan, so it never reaches this component
  useEffect(() => {
    if (values.path === 'hvac' && !values.salesOrService) {
      setFieldValue('salesOrService', 'sales')
    }
  }, [values.path, values.salesOrService, setFieldValue])

  return <HvacSales {...props} />
}

HVAC.info = {
  title: 'Eligibility',
  key: 'eligibility',
}

HVAC.propTypes = {
  currentStepIndex: PropTypes.number.isRequired,
  setValidationSchema: PropTypes.func.isRequired,
  setBlockNextStepUntilHowHeated: PropTypes.func,
  values: PropTypes.object,
}

export default HVAC
